import React,{useEffect} from "react";
import { Box, Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { Autocomplete } from '@material-ui/lab'
import { useTranslation } from "react-i18next";
import moment from "moment";
import _ from "lodash";
import FormSectionHeader from "../FormSectionHeader";
import SelectWithInput from "../SelectWithInput";
import { ControlPointDuplicateSharp } from "@material-ui/icons";
import { getUserPreference } from "../../../../utilities/common";
const useStyles = makeStyles((theme)=> ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}))


function InProgressForm(props) {
  const classes = useStyles();
  const {t} = useTranslation('incidentManagement');
  const userPref = getUserPreference();
  const { data, userList, statusList, onFormChange, ...rest } = props;
  const { causedByList, rootCauseList, resultList, actionResultList, correctiveActionList } = statusList;

  const getDataFromList = (list, id) => {
    return _.find(list, {'id': id});
  }

  return (
    <Box {...rest}>
      <FormSectionHeader
        title={t('in_progress')}
      />
      <form>
        <Grid container spacing={4} className={classes.section}>
          <Grid item xs={6}>
            <Autocomplete
              id="autocomplete-user-list"
              name="handler"
              options={userList}
              getOptionLabel={(option) => option.username}
              renderInput={(params) => <TextField {...params} label={t('handled_by')} variant='outlined'/>}
              fullWidth
              value={_.find(userList, {'id': parseInt(data.handler)|| null})}
              onChange={(event, newValue) => {
                event.target.name = "handler"
                event.target.value = newValue?.id //we want the id instead of the default index
                onFormChange(event) //set for actual data change
              }}
            />
          </Grid>
          <SelectWithInput 
            selectGridProps={{item: true, xs:6}}
            inputGridProps={{item: true, xs:12}}
            selectArray={causedByList}
            selectLabel={t('caused_by')}
            inputLabel={t('caused_by_detail')}
            selectName='caused_by'
            inputName='caused_by_detail'
            selectValue={data.caused_by}
            inputValue={data.caused_by_detail}
            handleChange={onFormChange}
            selectRequired
          />
          <SelectWithInput 
            selectGridProps={{item: true, xs:12}}
            inputGridProps={{item: true, xs:12}}
            selectArray={rootCauseList}
            selectLabel={t('root_cause')}
            inputLabel={t('root_cause_detail')}
            selectName='root_cause'
            inputName='root_cause_detail'
            selectValue={data.root_cause}
            inputValue={data.root_cause_detail}
            handleChange={onFormChange}
            selectRequired
            inputRequired
          />
          <SelectWithInput 
            selectGridProps={{item: true, xs:12}}
            inputGridProps={{item: true, xs:12}}
            selectArray={resultList}
            selectLabel={t('result_type')}
            inputLabel={t('result_type_detail')}
            selectName='result_type'
            inputName='result_detail'
            selectValue={data.result_type}
            inputValue={data.result_type_detail}
            handleChange={onFormChange}
            inputRequired
          />
          <SelectWithInput 
            selectGridProps={{item: true, xs:12}}
            inputGridProps={{item: true, xs:12}}
            selectArray={correctiveActionList}
            selectLabel={t('remedial_corrective_action')}
            inputLabel={t('remedial_corrective_action_detail')}
            selectName='corrective_action'
            inputName='corrective_action_detail'
            selectValue={data.corrective_action}
            inputValue={data.corrective_action_detail}
            handleChange={onFormChange}
            inputRequired
          />
          <Grid item xs={12}>
            <TextField
              id="input-notes"
              label={t('notes')}
              name="notes"
              variant='outlined'
              defaultValue={data.notes}
              multiline
              onChange={onFormChange}
              rows={4}
              fullWidth
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  )
}

export default InProgressForm;